import Swiper from 'swiper';
import { Navigation, EffectFade, Pagination, Autoplay } from 'swiper/modules';

let sliderModules = document.querySelectorAll('.module-slider');

sliderModules.forEach(function (module) {
    let swiperEl = module.querySelector('.swiper');
    let next = module.querySelector('.slider-nav-next');
    let prev = module.querySelector('.slider-nav-prev');
    let pagination = module.querySelector('.slider-pagination');
    let numbers = module.querySelector('.slider-nav-numbers');

    if (swiperEl) {

        let columns = swiperEl.dataset.sliderColumns;
        let paginationEnabled = swiperEl.dataset.sliderPagination;
        let animation = swiperEl.dataset.sliderAnimation;
        let autoplayEnabled = swiperEl.dataset.sliderAutoplay;
        let autoplaySpeed = swiperEl.dataset.sliderAutoplaySpeed;
        let loop = swiperEl.dataset.sliderLoop;
        let centeredSlides = swiperEl.dataset.sliderCenteredSlides;
        let desktopSlidesPerView = swiperEl.dataset.sliderColumnsDesktop;
        let tabletSlidesPerView = swiperEl.dataset.sliderColumnsTablet;
        let mobileSlidesPerView = swiperEl.dataset.sliderColumnsMobile;

        let breakpoints = {
            320: {
                slidesPerView: mobileSlidesPerView ? mobileSlidesPerView : 1,
                spaceBetween: 8,
            },
            640: {
                slidesPerView: tabletSlidesPerView ? tabletSlidesPerView : 2,
                spaceBetween: 8,
            },
            1024: {
                slidesPerView: desktopSlidesPerView ? desktopSlidesPerView : 3,
                spaceBetween: 16,
            }
        }

        if (columns && columns == '4' || desktopSlidesPerView == '4') {
            breakpoints = {
                320: {
                    slidesPerView: mobileSlidesPerView ? mobileSlidesPerView : 1.1,
                    spaceBetween: 8,
                },
                500: {
                    slidesPerView: tabletSlidesPerView ? tabletSlidesPerView : 2,
                },
                640: {
                    slidesPerView: tabletSlidesPerView ? tabletSlidesPerView : 3,
                },
                1024: {
                    slidesPerView: desktopSlidesPerView ? desktopSlidesPerView : 4,
                    spaceBetween: 16,
                }
            }
        }

        if (columns && columns == '2' || desktopSlidesPerView == '2') {
            breakpoints = {
                640: {
                    slidesPerView: desktopSlidesPerView ? desktopSlidesPerView : 2,
                    spaceBetween: 16,
                }
            }
        }

        if (columns && columns == '1' || desktopSlidesPerView == '1') {
            breakpoints = {
                640: {
                    slidesPerView: desktopSlidesPerView ? desktopSlidesPerView : 1,
                    spaceBetween: 16,
                }
            }
        }

        let updateSliderNumbers = function (index, length) {
            if (numbers) {
                numbers.innerHTML = index + 1 + '/' + length;
            }
        }

        let swiperParams = {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 8,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: breakpoints,
            on: {
                init: function (swiper) {
                    updateSliderNumbers(swiper.activeIndex, swiper.slides.length);
                },
                activeIndexChange: function (swiper) {
                    updateSliderNumbers(swiper.activeIndex, swiper.slides.length);
                },
            },
        };

        if (animation && animation == 'fade') {
            swiperParams.modules.push(EffectFade);
            swiperParams.effect = 'fade';
            swiperParams.fadeEffect = {
                crossFade: true
            };
        }

        if (paginationEnabled) {
            swiperParams.modules.push(Pagination);
            swiperParams.pagination = {
                el: pagination,
                type: 'bullets',
                clickable: true
            };
        }

        if (autoplayEnabled && autoplaySpeed) {
            swiperParams.autoplay = {
                delay: autoplaySpeed * 1000,
                disableOnInteraction: true
            };
            swiperParams.loop = true;
            swiperParams.modules.push(Autoplay);
        }

        if (loop) {
            swiperParams.loop = true;
        }

        if (centeredSlides) {
            swiperParams.centeredSlides = true;
        }

        // remove navigation if there is only 1 slide
        const totalSlides = swiperEl.querySelectorAll('.swiper .swiper-slide').length;
        if (totalSlides <= 1) {
            next.style.display = 'none';
            prev.style.display = 'none';
        }
        
        const swiper = new Swiper(swiperEl, swiperParams);
    }
});